import MuiCircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';

export type { CircularProgressProps };

export const CircularProgress = (props: CircularProgressProps) => (
  <MuiCircularProgress {...props} />
);
